
import { store } from '@/store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import WorkOrdersEnum from '@/enums/modules/routes/workOrders'

const WorkOrdersStoreModule = () => import(/* webpackChunkName: "WorkOrders" */ '../store/modules/workOrders')
const WorkOrdersPlaceholder = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/WorkOrdersPlaceholder')
const WorkOrders = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/WorkOrders')
const BreakdownCase = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/BreakdownCase')
const Kitting = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/Kitting')
const KittingBeta = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/KittingBeta')
const Disposal = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/Disposal')
const DeKitting = () => import(/* webpackChunkName: "WorkOrders" */ '@/components/workOrders/DeKitting')

const dynamicModuleRegistrationProductsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'workOrders',
    module: WorkOrdersStoreModule,
    store,
    modulePath: 'workOrders'
  }
}

const decideKittingRoute = (to, from, next) => {
  const kittingCreationEnabled = store.getters['WorkOrderKittingCreationEnabled']
  let name
  if (!kittingCreationEnabled) name = WorkOrdersEnum.Kitting
  else if (kittingCreationEnabled && to.name === WorkOrdersEnum.Kitting) name = WorkOrdersEnum.KittingBeta
  if (name !== to.name) next({ name })
  else next()
}

// ******************************************************
// ****************** Route Definitions *****************
// ******************************************************

export default [
  {
    path: '/inventory/work-orders',
    component: WorkOrdersPlaceholder,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationProductsArgs()).then(
        () => next()
      )
    },
    meta: { showSideNav: true },
    children: [
      {
        path: 'breakdown-case',
        name: WorkOrdersEnum.BreakdownCase,
        component: BreakdownCase
      },
      {
        path: 'kitting',
        name: WorkOrdersEnum.Kitting,
        component: Kitting,
        beforeEnter: decideKittingRoute
      },
      {
        path: 'kitting-beta',
        name: WorkOrdersEnum.KittingBeta,
        component: KittingBeta,
        beforeEnter: decideKittingRoute
      },
      {
        path: 'kitting-beta/:kittingId',
        name: WorkOrdersEnum.KittingBetaReadOnly,
        props: (route) => ({
          kittingId: parseInt(route.params.kittingId)
        }),
        component: KittingBeta,
        beforeEnter: decideKittingRoute
      },
      {
        path: 'kitting-beta/:kittingId/copyEdit',
        name: WorkOrdersEnum.KittingBetaEditOrder,
        props: (route) => ({
          kittingId: parseInt(route.params.kittingId),
          copyEdit: true
        }),
        component: KittingBeta,
        beforeEnter: decideKittingRoute
      },
      {
        path: 'disposal',
        name: WorkOrdersEnum.Disposal,
        component: Disposal
      },
      {
        path: 'de-kitting',
        name: WorkOrdersEnum.DeKitting,
        component: DeKitting
      },
      {
        path: '/',
        name: WorkOrdersEnum.WorkOrders,
        component: WorkOrders
      }
    ]
  }
]
